import { callMCPTool } from './gateway';

const SERVER_NAME = 'CIPP-MCP';

/**
 * CIPP-MCP API - Microsoft 365 tenant management
 */

/**
 * List all tenants accessible via GDAP
 */
export const listTenants = async () => {
  return callMCPTool(SERVER_NAME, 'list_tenants');
};

/**
 * Get detailed information about a specific tenant
 * @param {string} tenantId - Tenant ID
 */
export const getTenant = async (tenantId) => {
  return callMCPTool(SERVER_NAME, 'get_tenant', { tenant_id: tenantId });
};

/**
 * List users for a tenant
 * @param {string} tenantId - Tenant ID
 */
export const listUsers = async (tenantId) => {
  return callMCPTool(SERVER_NAME, 'list_users', { tenant_id: tenantId });
};

/**
 * Get license information for a tenant
 * @param {string} tenantId - Tenant ID
 */
export const getLicenses = async (tenantId) => {
  return callMCPTool(SERVER_NAME, 'get_licenses', { tenant_id: tenantId });
};

/**
 * Get security defaults for a tenant
 * @param {string} tenantId - Tenant ID
 */
export const getSecurityDefaults = async (tenantId) => {
  return callMCPTool(SERVER_NAME, 'get_security_defaults', { tenant_id: tenantId });
};

/**
 * Get conditional access policies for a tenant
 * @param {string} tenantId - Tenant ID
 */
export const getConditionalAccessPolicies = async (tenantId) => {
  return callMCPTool(SERVER_NAME, 'get_conditional_access', { tenant_id: tenantId });
};

/**
 * Get secure score for a tenant
 * @param {string} tenantId - Tenant ID
 */
export const getSecureScore = async (tenantId) => {
  return callMCPTool(SERVER_NAME, 'get_secure_score', { tenant_id: tenantId });
};

/**
 * Get mailbox statistics for a tenant
 * @param {string} tenantId - Tenant ID
 */
export const getMailboxStats = async (tenantId) => {
  return callMCPTool(SERVER_NAME, 'get_mailbox_stats', { tenant_id: tenantId });
};

export default {
  listTenants,
  getTenant,
  listUsers,
  getLicenses,
  getSecurityDefaults,
  getConditionalAccessPolicies,
  getSecureScore,
  getMailboxStats,
};
